$(document).ready(function(){

    var stopAllVideos = function($self){
        $.each($self.$slides, function (i, $slide) {
            if($slide.$videoIframe.length){
                $slide.$videoIframe[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}','*');
                $slide.$videoBbutton.parent().removeClass('video-visible').find('>:not(.flex-video)').fadeIn(500);
             }
        });
    }

    $('.story-carousel-module-container').each(function(){
        var $self = $(this);
        $self.$slides = [];
        $self.$sliderContainer = $self.find('.slider-container');

        $.each($self.find('.story-carousel-item'), function (i, slide) {
            var $slide = $(slide);
            $slide.$videoBbutton = $slide.find('.video-button');
            $slide.$videoIframe = false;

            setTimeout(function(){
                $slide.$videoIframe = $slide.find('.flex-video > iframe');
                if($slide.$videoIframe.length){
                    $slide.$videoIframe[0].src += '&enablejsapi=1';
                }
            },100);

            if($slide.$videoBbutton.length){
                $slide.$videoBbutton.on('click', function () {
                    if(!$slide.$videoIframe) return;

                    $slide.$videoBbutton.parent().addClass('video-visible').find('>:not(.flex-video)').fadeOut(500, function() {
                        $slide.$videoIframe[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}','*');
                    });
                })
            }

            $self.$slides[$self.$slides.length] = $slide;
        });

        $self.$sliderContainer.on('beforeChange', function(){
            stopAllVideos($self);
        })
    });
})